function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled from 'styled-components';
import { padding, font } from '../../utils/helpers';
var InputHelper = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      hasIcon = _ref.hasIcon;
  var colors = theme.colors,
      text = theme.text,
      input = theme.input;
  return _extends({}, padding(_extends({}, input.helper, {
    paddingRight: !hasIcon ? input.paddingRight : input.paddingRight * 2 + input.icon.size
  })), font({
    fontFamily: text.shared.normal.fontFamily,
    fontWeight: text.shared.normal.fontWeight,
    fontSize: text.mention.xlarge.fontSize,
    lineHeight: text.mention.xlarge.lineHeight
  }), {
    color: colors[input.helper["default"].color]
  });
});
export default InputHelper;